export class ApiError extends Error {
  constructor(message: string, readonly status: number, readonly code?: string) { super(message); }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: { "Content-Type": "application/json", ...init?.headers },
  });
  if (response.status === 204) return undefined as T;
  const body = await response.json().catch(() => ({})) as { error?: string; code?: string };
  if (!response.ok) throw new ApiError(body.error ?? "通信に失敗しました", response.status, body.code);
  return body as T;
}

export type Day = {
  id: string; operationDate: string; operationStatus: "operating" | "cancelled_all";
  inputStatus: "not_started" | "in_progress" | "completed"; visitorCount: number | null;
  note: string; revision: number;
};
export type RouteOperation = { id: string; routeId: string; code: string; name: string;
  operationMode: "scheduled" | "piston" | "free"; largeEnabled: 0 | 1 | boolean; revision: number };
export type ScheduledTrip = { id: string; routeId: string; direction: "outbound" | "inbound";
  serviceLabel: "1便" | "2便" | "3便" | "4便" | "大型" | "インバウンド"; plannedMinute: number; sortOrder: number };
export type TripRecord = { id: string; routeDayOperationId: string; scheduledTripId: string | null;
  direction: "outbound" | "inbound"; operationKind: "scheduled" | "extra" | "piston" | "inbound";
  serviceLabel: string; plannedMinute: number | null; actualMinute: number; passengerCount: number;
  clientRequestId: string; entryOrder?: number | null; revision: number; updatedAt: string };
export type DayPayload = { day: Day; routeOperations: RouteOperation[]; scheduledTrips: ScheduledTrip[]; records: TripRecord[] };
